import { useTenant } from "../../Contexts/TenantContext";
import { formatCnpj } from "../../Utils/DataFormatters";

const FooterInfo = () => {
  const { tenant } = useTenant();

  return (
    <div className="bg-neutral-900">
      {/* Both lines need about 800px side by side, so they stay stacked until 1020px */}
      <div className="max-w-[94rem] mx-auto px-4 sm:px-6 py-3 flex flex-col justify-between text-xs gap-2 sm:py-8 lg:items-center lg:flex-row lg:gap-0">
        <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[10px] leading-snug whitespace-nowrap sm:flex-nowrap lg:justify-start sm:text-xs sm:leading-normal text-gray-300">
          <span>© {new Date().getFullYear()}</span>
          <span aria-hidden="true">•</span>
          <a
            href="https://essaecommerce.com"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 hover:text-white transition"
          >
            <img src="/logo.png" alt="ESSA E-COMMERCE" className="h-4 w-auto" />
            <span>ESSA E-COMMERCE</span>
          </a>
          {/* Below 480px the last item gets its own line instead of a dangling bullet */}
          <span aria-hidden="true" className="hidden sm:inline">•</span>
          <span className="basis-full text-center sm:basis-auto">Todos os direitos reservados</span>
        </p>
        {tenant?.companyName && tenant?.cnpj && (
          <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[10px] leading-snug whitespace-nowrap sm:flex-nowrap lg:justify-start sm:text-xs sm:leading-normal text-gray-300">
            <span>{tenant.companyName}</span>
            <span aria-hidden="true" className="hidden sm:inline">•</span>
            <span className="basis-full text-center sm:basis-auto">CNPJ: {formatCnpj(tenant.cnpj)}</span>
          </p>
        )}
      </div>
    </div>
  );
};

export default FooterInfo;
